import styled from 'styled-components'

export const RoomsPage = styled.div` 
width: 90%; 
height: 95vh; 
`

export const RoomCard = styled.div`
display: flex; 
justify-content: center; 
align-items: center;
height: 250px;
font-family: "Roboto", sans-serif;
font-weight: 400; 
font-size: 20px; 
color: #8E8E93; 
letter-spacing: 0.55px;
text-align: center;
`
export const MainLabel = styled.p`
font-family: "Roboto", sans-serif;
font-weight: 400;
font-size: 20px;
color: #8E8E93;
letter-spacing: 0.55px;
text-align: center;
`

export const DataStructures = styled.div`

font-family: "Roboto", sans-serif;
font-weight: 400; 
font-size: 20px; 
color: black; 
letter-spacing: 0.55px;
text-align: center;
width: 410px;
max-width: 410px;
position: absolute;
top: 10px;
left: 10px;
box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
word-wrap: break-word;
`

export const CategoriesPage = styled.div` 
display: flex;
flex-flow: column; 
width: 100%; 
height: 95vh; 
justify-content: center; 
align-items: center;
`

export const CategoryCard = styled.div`
display: flex; 
justify-content: center; 
align-items: center;
height: 100px;
font-family: "Roboto", sans-serif;
font-weight: 400; 
font-size: 20px; 
color: #8E8E93; 
letter-spacing: 0.55px;
text-align: center;
`